import React from 'react';
import { Button, Box } from '@material-ui/core';

interface SaveCancelButtonsProps {
  onSave: () => void;
  onCancel: () => void;
  saveLoading?: boolean;
  saveDisabled?: boolean;
  cancelDisabled?: boolean;
  saveText?: string;
  cancelText?: string;
}

export default function SaveCancelButtons({
  onSave,
  onCancel,
  saveLoading = false,
  saveDisabled = false,
  cancelDisabled = false,
  saveText = 'Save',
  cancelText = 'Cancel'
}: SaveCancelButtonsProps) {
  return (
    <Box display="flex" justifyContent="flex-end" mt={2} mb={2}>
      <Button
        onClick={onCancel}
        disabled={cancelDisabled}
        style={{ marginRight: 8 }}
      >
        {cancelText}
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={onSave}
        disabled={saveDisabled || saveLoading}
      >
        {saveLoading ? 'Saving...' : saveText}
      </Button>
    </Box>
  );
}
